export default "__VITE_ASSET__BzdB2KTA__"